// Copyright (c) 2018 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {createRequestPayload} from '../services/create-payload';
import {routerActions} from 'react-router-redux';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';
import {updatePartRequest} from '../../shared/repositories';

export const submitRequestForm = (form, partReturn) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const payload = createRequestPayload(form, partReturn);

        try {

            await updatePartRequest(payload);

            successAlertBar(translate('REQUEST_UPDATED_SUCCESSFULLY'));

            dispatch(routerActions.goBack());

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/part-requests/request-details/action-creators/submit-request-form.js